import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Alert/alert';
import accessibleStyles from '@patternfly/react-styles/css/utilities/Accessibility/accessibility';
import { AlertIcon } from './AlertIcon';
import { capitalize, getOUIAProps } from '../../helpers';
import { AlertContext } from './AlertContext';
export var AlertVariant;

(function (AlertVariant) {
  AlertVariant["success"] = "success";
  AlertVariant["danger"] = "danger";
  AlertVariant["warning"] = "warning";
  AlertVariant["info"] = "info";
  AlertVariant["default"] = "default";
})(AlertVariant || (AlertVariant = {}));

export var Alert = function Alert(_a) {
  var _a$variant = _a.variant,
      variant = _a$variant === void 0 ? AlertVariant.default : _a$variant,
      _a$isInline = _a.isInline,
      isInline = _a$isInline === void 0 ? false : _a$isInline,
      _a$isLiveRegion = _a.isLiveRegion,
      isLiveRegion = _a$isLiveRegion === void 0 ? false : _a$isLiveRegion,
      _a$variantLabel = _a.variantLabel,
      variantLabel = _a$variantLabel === void 0 ? "".concat(capitalize(variant), " alert:") : _a$variantLabel,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? "".concat(capitalize(variant), " Alert") : _a$ariaLabel,
      actionClose = _a.actionClose,
      actionLinks = _a.actionLinks,
      title = _a.title,
      _a$children = _a.children,
      children = _a$children === void 0 ? '' : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      ouiaId = _a.ouiaId,
      props = __rest(_a, ["variant", "isInline", "isLiveRegion", "variantLabel", 'aria-label', "actionClose", "actionLinks", "title", "children", "className", "ouiaId"]);

  var getHeadingContent = React.createElement(React.Fragment, null, React.createElement("span", {
    className: css(accessibleStyles.screenReader)
  }, variantLabel), title);
  var customClassName = css(styles.alert, isInline && styles.modifiers.inline, variant !== AlertVariant.default && styles.modifiers[variant], className);
  return React.createElement("div", Object.assign({}, props, {
    className: customClassName,
    "aria-label": ariaLabel
  }, getOUIAProps('Alert', ouiaId), isLiveRegion && {
    'aria-live': 'polite',
    'aria-atomic': 'false'
  }), React.createElement(AlertIcon, {
    variant: variant
  }), React.createElement("h4", {
    className: css(styles.alertTitle)
  }, getHeadingContent), actionClose && React.createElement(AlertContext.Provider, {
    value: {
      title: title,
      variantLabel: variantLabel
    }
  }, React.createElement("div", {
    className: css(styles.alertAction)
  }, actionClose)), children && React.createElement("div", {
    className: css(styles.alertDescription)
  }, children), actionLinks && React.createElement("div", {
    className: css(styles.alertActionGroup)
  }, actionLinks));
};